module.exports = __webpack_public_path__ + "img/temperature.e7b479bf.svg";